import { render } from "./AccordionList.vue?vue&type=template&id=0e07088e"
import script from "./AccordionList.vue?vue&type=script&lang=js"
export * from "./AccordionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__